const getOfficeByOkato = (okato, offices) => {
  if (!okato || !offices.length) {
    return null;
  }

  return offices.find(office => office.okato.includes(okato.toString()));
};

export default getOfficeByOkato;
